module.exports = __webpack_public_path__ + "img/frame5.4715bcb7.jpg";